"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

/* eslint-disable no-eq-null */
function HelpIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 6C10.957 6.00132 9.95719 6.41622 9.2197 7.1537C8.48222 7.89118 8.06732 8.89104 8.066 9.934H10.066C10.066 8.867 10.934 8 12 8C13.066 8 13.934 8.867 13.934 9.934C13.934 10.532 13.453 10.966 12.718 11.56C12.4779 11.7481 12.2473 11.948 12.027 12.159C11.029 13.156 11 14.215 11 14.333V15H13L12.999 14.367C13 14.351 13.032 13.981 13.44 13.574C13.59 13.424 13.779 13.274 13.975 13.116C14.754 12.485 15.933 11.532 15.933 9.934C15.9322 8.89106 15.5176 7.89104 14.7802 7.15347C14.0429 6.4159 13.0429 6.00106 12 6ZM11 16H13V18H11V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z",
    fill: "currentColor"
  }));
}

const StyledDisplaySmall = (0, _styledComponents.default)(_blocks.DisplaySmall)`
  position: relative;
  display: flex;
  justify-content: center;
  gap: ${_blocks.spacing.extraTight};
  margin-bottom: ${_blocks.spacing.default};
  font-weight: ${_blocks.fontWeight.bold};

  svg {
    color: ${_blocks.color.theme.icon.subdued};
  }
`;
const StyledModal = (0, _styledComponents.default)(_blocks.Modal)`
  header > div {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
  }
`;
const ContentWrap = (0, _styledComponents.default)(_blocks.ModalContent)`
  padding: ${_blocks.spacing.default} ${_blocks.spacing.loose};
`;
const HelpButton = _styledComponents.default.button`
  all: unset;
`;

function InfoText({
  ruleName,
  ruleDescription
}) {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledModal, {
    title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ruleName),
    isOpen: isOpen,
    onRequestClose: () => setIsOpen(false)
  }, /*#__PURE__*/_react.default.createElement(ContentWrap, null, /*#__PURE__*/_react.default.createElement(_blocks.Markdown, null, ruleDescription))), /*#__PURE__*/_react.default.createElement(StyledDisplaySmall, null, /*#__PURE__*/_react.default.createElement("span", null, "Rule: ", ruleName), ruleDescription != null && /*#__PURE__*/_react.default.createElement(HelpButton, {
    onClick: () => setIsOpen(true),
    title: "View rule description"
  }, /*#__PURE__*/_react.default.createElement(HelpIcon, null))));
}

InfoText.propTypes = {
  ruleName: _propTypes.default.string.isRequired
};
var _default = InfoText;
exports.default = _default;
module.exports = exports.default;